import { TypedUseSelectorHook, useDispatch, useSelector as _useSelector, shallowEqual as _shallowEqual } from 'react-redux';
import type { RootState, AppDispatch } from './index';

// Use throughout your app instead of plain `useAppDispatch` and `useAppSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = _useSelector;
export const shallowEqual = _shallowEqual;
